'use strict';

export default class StablishmentMap {
  constructor(options) {
    console.log('stablishmentMap module');

    const defaults = {
        mapElement: '#map'
    };
    this.options = Object.assign({}, defaults, options);

    this.map_options = {
        mapTypeId: google.maps.MapTypeId.ROADMAP //set map type to road map
    };

    //auto init
    this._getLatLng()._drawMap();

  }

  _getLatLng() {

    this.myLatLng = {lat: $(this.options.mapElement).data('lat') * 1, lng: $(this.options.mapElement).data('lng')  * 1};
    return this;
  }

  _drawMap() {

    if(this.myLatLng.lat == 0 && this.myLatLng.lng == 0) return;

    this.map = new google.maps.Map(document.getElementById('map'), {
      zoom: 14,
      center: this.myLatLng
    });

    this.marker = new google.maps.Marker({
      position: this.myLatLng,
      map: this.map
    });

  }
}
